import { useEffect, useRef } from 'react';
import './index.scss';
import { useDispatch } from 'react-redux';
import { headerActions } from '@/reducers/HeaderConfigs';
import rightContentBlack from '@/images/header/icon_share_black.png';
import Loading from '@/components/HLoading';
import Api from '@/api';
import { useNavigate } from 'react-router';
const Index = () => {
  const dispatch = useDispatch();
  const loadingRef = useRef<any>(); //loading
  const navigate = useNavigate();

  useEffect(() => {
    loadingRef.current.open();
    setTimeout(() => {
      loadingRef.current.close();
    }, 1500);
    dispatch(
      headerActions.setHeader({
        rightContent: <img src={rightContentBlack} alt="返回" />,
        rightClick: async () => {
          const res = await Api.getList({ size: 10 });
          console.log(res);
          console.log('你好我点击了');
        },
      })
    );
  });
  const linkUrl = () => {
    navigate('/error');
  };
  return (
    <div className="myindex">
      <p onClick={linkUrl}>欢迎使用</p>
      <Loading cRef={loadingRef} />
    </div>
  );
};

export default Index;
